import { render, staticRenderFns } from "./AddressSuggestionsModal.vue?vue&type=template&id=9e325e2e&scoped=true"
import script from "./AddressSuggestionsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddressSuggestionsModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AddressSuggestionsModal.vue?vue&type=style&index=0&id=9e325e2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e325e2e",
  null
  
)

export default component.exports